import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "suggestions"]
  static values = { popularTags: Array }

  connect() {
    this.updateSuggestions()
    this.updateTagButtons()
  }

  inputChanged() {
    this.updateSuggestions()
    this.updateTagButtons()
  }

  updateSuggestions() {
    const currentValue = this.inputTarget.value
    const existingTags = currentValue.split(',').map(tag => tag.trim()).filter(tag => tag)
    const lastTag = existingTags[existingTags.length - 1] || ""
    
    if (lastTag.length > 0) {
      // Ensure popularTagsValue is an array
      const popularTags = Array.isArray(this.popularTagsValue) ? this.popularTagsValue : []
      const filteredTags = popularTags.filter(tag => 
        tag.toLowerCase().includes(lastTag.toLowerCase()) && 
        !existingTags.includes(tag)
      )
      this.showSuggestions(filteredTags)
    } else {
      this.hideSuggestions()
    }
  }

  showSuggestions(tags) {
    if (!this.hasSuggestionsTarget) {
      this.createSuggestionsElement()
    }
    
    if (tags.length > 0) {
      this.suggestionsTarget.innerHTML = tags.map(tag => 
        `<button type="button" class="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded hover:bg-blue-200" data-action="click->tags-input#selectTag" data-tag="${tag}">${tag}</button>`
      ).join('')
      this.suggestionsTarget.style.display = 'block'
    } else {
      this.hideSuggestions()
    }
  }

  hideSuggestions() {
    if (this.hasSuggestionsTarget) {
      this.suggestionsTarget.style.display = 'none'
    }
  }

  selectTag(event) {
    const selectedTag = event.target.dataset.tag
    const currentValue = this.inputTarget.value
    const existingTags = currentValue.split(',').map(tag => tag.trim()).filter(tag => tag)
    
    // Toggle tag - remove if exists, add if doesn't exist
    if (existingTags.includes(selectedTag)) {
      // Remove the tag
      const updatedTags = existingTags.filter(tag => tag !== selectedTag)
      this.inputTarget.value = updatedTags.join(', ')
    } else {
      // Add the new tag
      existingTags.push(selectedTag)
      this.inputTarget.value = existingTags.join(', ')
    }
    
    this.hideSuggestions()
    this.updateTagButtons()
    this.inputTarget.focus()
  }

  updateTagButtons() {
    const currentValue = this.inputTarget.value
    const existingTags = currentValue.split(',').map(tag => tag.trim()).filter(tag => tag)
    
    // Find all tag buttons and update their styling
    const tagButtons = this.element.querySelectorAll('[data-action*="selectTag"]')
    tagButtons.forEach(button => {
      const tagName = button.dataset.tag
      if (existingTags.includes(tagName)) {
        // Selected state - blue background
        button.className = "inline-flex items-center px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded hover:bg-blue-200 transition-colors cursor-pointer border border-blue-300"
      } else {
        // Unselected state - gray background
        button.className = "inline-flex items-center px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors cursor-pointer"
      }
    })
  }

  createSuggestionsElement() {
    const suggestions = document.createElement('div')
    suggestions.className = 'mt-2 p-2 bg-white border border-gray-300 rounded-md shadow-sm space-x-1'
    suggestions.style.display = 'none'
    suggestions.setAttribute('data-tags-input-target', 'suggestions')
    this.inputTarget.parentNode.appendChild(suggestions)
  }
}